<template>
  <div class="detail">
    <r-pointer :textName="$t('private.order.number') + ' ' + parent.outTradeNo" />
    <dl class="list summary">
      <dt v-text="$t('private.order.summary')"></dt>
      <dd>
        <span>{{ `${$t('private.order.number')}：${parent.outTradeNo}` }}</span>
        <span>{{ `${$t('private.order.type')}：` }} {{ parent.payPlatform > -1 && $t(`private.order.payPlatform[${parent.payPlatform}]`) || '' }}</span>
      </dd>
      <dd>
        <span>{{ `${$t('private.order.time')}：${parent.createTime}` }}</span>
        <span>{{ `${$t('private.order.payTime')}：${parent.payTime}` }}</span>
      </dd>
    </dl>
    <dl class="list order">
      <dt v-text="$t('private.order.details')"></dt>
      <dd class="sub-title">
        <span v-text="$t('private.order.detail.number')"></span>
        <span v-text="$t('private.order.detail.type')"></span>
        <span v-text="$t('private.order.detail.detail')"></span>
        <span class="t_right" v-text="$t('private.order.detail.cost')"></span>
      </dd>
      <dd class="item" :key="index" v-for="(child, index) in children">
        <!--{{ child }}-->
        <span class="item-block">{{ child.orderNo }}</span>
        <span class="item-block">
          {{ child.productCategory === 'NP' ? $t('novice.titleH31') : child.productCategory }}
          <a v-if="child.productName.indexOf('活动兑换卡') !== -1" class="font-bold color-main" @click="$router.push('/card')">&nbsp;&nbsp;{{ $t('private.order.viewCardPack') }}</a>
        </span>
        <div class="item-block">
          <p v-if="child.orderModel === 2" v-text="$tc('private.order.detail.typeValue', 1)"></p>
          <p v-text="$tc('private.order.detail.typeValue', 2)" v-else></p>
          <!--<p>实例号：xxxxxxxx</p>-->
          <p>{{ $t('private.order.detail.time', {n: child.orderMonth}) }}</p>
          <template v-if="child.productNo">
            <p @click="toDetail(child.productNo)">
              {{ $t('private.order.detail.prodName') }}：
              <u style="cursor: pointer">{{ child.prodName }}</u>
            </p>
            <p>{{ `${$t('private.order.detail.prodAuthor')}：${child.prodName}` }}</p>
            <p>{{ `${$t('private.order.detail.prodTag')}：${child.tags}` }}</p>
            <p>{{ `${$t('private.order.detail.prodVersion')}：${child.prodVersion}` }}</p>
            <p>{{ `${$t('private.order.detail.prodVersionTime')}：${child.shelvesOnTime}` }}</p>
          </template>
        </div>
        <div class="item-block t_right cost">
          <s v-text="'￥' + moneyComma(child.origPrice)"></s>
          <span v-text="'￥' + moneyComma(child.dctPrice)"></span>
        </div>
      </dd>
    </dl>
    <!-- 代理商 -->
    <dl class="list agent" v-if="agentInfo.promotionCode">
      <dt v-text="$t('private.order.agent')"></dt>
      <dd class="sub-title">
        <span v-text="$t('private.order.agentTh[0]')"></span>
        <span v-text="$t('private.order.agentTh[1]')"></span>
        <span v-text="$t('private.order.agentTh[2]')"></span>
        <span v-text="$t('private.order.agentTh[3]')"></span>
        <span class="t_right" v-text="$t('private.order.agentTh[4]')"></span>
      </dd>
      <dd class="item">
        <span class="item-block">{{ agentInfo.promotionCode || '-' }}</span>
        <span class="item-block">{{ agentInfo.companyName || '-' }}</span>
        <div class="item-block">{{ agentInfo.companyAddress || '-' }}</div>
        <div class="item-block">{{ agentInfo.phoneNum || '-' }}</div>
        <div class="item-block t_right cost">
          <span v-if="agentInfo.discount">{{ $t('private.order.dis', { dis: agentInfo.discount}) }}</span>
          <div v-else>-</div>
        </div>
      </dd>
    </dl>
    <p class="total">
      {{ $t('private.order.detail.total') }}：<span v-text="moneyComma(total)"></span>
    </p>
    <a-button type="primary" @click="$router.go(-1)">{{ $t('private.common.back') }}</a-button>
  </div>
</template>

<script>
import { getOrderDetail, getChildrenDetails } from '@api/order'
import { moneyComma } from '@/utils/util'
export default {
  name: 'OrderDetail',
  data () {
    return {
      children: [],
      parent: {},
      // 代理商
      agentInfo: {}
    }
  },
  computed: {
    'outTradeNo' () {
      return this.$route.params.outTradeNo
    },
    'total' () {
      const allArr = this.children.map(row => row.dctPrice)
      const sum = allArr.length ? allArr.reduce((prev, cur) => prev + cur) : 0
      return sum
    }
  },
  created () {
    // console.log(this.outTradeNo)
    this.getDetail()
  },
  filters: {
    getPayType (value) {
      let type = ''
      switch (value) {
        case 0:
          // 支付宝
          type = window.$globalHub.$t('private.order.payType.ali')
          break
        case 1:
          // 微信
          type = window.$globalHub.$t('private.order.payType.wx')
          break
        case 2:
          // paypal
          type = window.$globalHub.$t('private.order.payType.paypal')
          break
        default:
      }
      return type
    }
  },
  methods: {
    moneyComma,
    getDetail () {
      getChildrenDetails(this.outTradeNo).then(res => {
        // console.log(res, '<<<<<<')
        this.children = res
      })
      getOrderDetail(this.outTradeNo).then(res => {
        // console.log(res, '5555555555')
        this.parent = res
        this.agentInfo = this.parent.agent || {}
      })
    },
    toDetail (id) {
      if (id) {
        window.open(this.$url.baseUrl + '/store/detail/' + id)
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@assets/styles/base/color.less";
.detail{
  background-color: #fff;
  height: 100%;
  padding: 0 24px;
  .list{
    dt{
      line-height: 42px;
      padding: 0 24px;
      background:rgba(240,240,240,1);
      box-shadow:0px 1px 0px 0px rgba(238,238,238,1);
      border-left: 4px solid #4977FC;
      font-size: 16px;
      color: #333333;
    }
    dd{
      line-height: 32px;
      box-shadow:0px 1px 0px 0px rgba(238,238,238,1);
      font-size: 14px;
      color: #666;
    }
    &.summary{
      margin-bottom: 17px;
      dd{
        span{
          display: inline-block;
          padding-left: 24px;
          width: 50%;
          &:first-child{
            border-right: 1px solid #EEEEEE;
          }
        }
      }
    }
    &.order{
      dd{
        &.sub-title{
          background-color: #FAFAFA;
          padding: 0 24px;
          span{
           display: inline-block;
           width: 25%;
           color: #333;
          }
        }
        &.item{
          padding: 10px 24px;
          .item-block{
            display: inline-block;
            width: 25%;
            vertical-align: top;
            &.cost{
              span{
                color: @money;
                margin-left: 10px;
              }
            }
            &.is-link{
              text-decoration: underline;
              cursor: pointer;
              color: #4977fc;
            }
          }
        }
      }
    }
    &.agent {
      margin-top: 17px;
      dd{
        &.sub-title{
          background-color: #FAFAFA;
          padding: 0 24px;
          span{
           display: inline-block;
           width: 22%;
           color: #333;
          }
        }
        &.item{
          padding: 10px 24px;
          .item-block{
            display: inline-block;
            width: 22%;
            vertical-align: top;
            &.cost{
              span{
                color: #FF4032;
                margin-left: 10px;
              }
            }
          }
        }
        .t_right {
          width: 12% !important;
        }
      }
    }
  }
  .total{
    margin-top: 36px;
    font-size: 14px;
    color: #262626;
    text-align: right;
    padding: 0 24px;
    span{
      font-size: 30px;
      color: @money;
      margin-left: 10px;
    }
  }
}
</style>
